<template>
  <table class="data-table ">
    <thead class="data-table__head ">
      <tr class="">
        <th>
          <v-simple-checkbox :value="checkedAll"
                             color="#2D9CDB"
                             @click="onCheckAll"/>
        </th>

        <th class="pl-0 v_text_default--text" >{{ $t('statistic.standmansTable.fio') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.standmansTable.totalSurveys') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.standmansTable.surveysByTotal') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.standmansTable.totalData') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.standmansTable.scanByTotal') }}</th>
      </tr>
    </thead>

    <tbody class="data-table__body v_bg_default">
      <tr v-for="standman in standmans" :key="standman._id">
        <td>
          <div class="first-column">
            <v-checkbox v-model="checkedStandmans"
                        :value="standman._id"
                        @change="onChange"/>

            <div class="standman-color"
                 :style="{ background: standman.color }"/>
          </div>
        </td>

        <td class="pl-0 v_text_default--text">
          {{ `${standman.name.first} ${standman.name.last}` }}
        </td>
        <td class="v_text_default--text">{{ standman.surveyCount }}</td>
        <td class="v_text_default--text">{{ countSurveysProcent(standman.surveyCount).toFixed(0) }} %</td>
        <td class="v_text_default--text">{{ standman.shardCount }}</td>
        <td class="v_text_default--text">{{ countShardProcent(standman.shardCount).toFixed(0) }} %</td>
      </tr>

      <tr>
        <td></td>
        <td class="pl-0">{{ standmans.length }}</td>
        <td>{{ countStandmansSurveyAndShard.surveys }}</td>
        <td></td>
        <td>{{ countStandmansSurveyAndShard.shards }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['standmans'],

  data: () => ({
    checkedAll: true,
    checkedStandmans: []
  }),

  computed: {
    countStandmansSurveyAndShard () {
      return this.$store.getters['statistics/countStandmansSurveyAndShard']
    }
  },

  watch: {
    standmans() {
      this.checkAll()

      this.$emit('onChange', this.checkedStandmans)
    }
  },

  created() {
    this.checkAll()

    this.$emit('onChange', this.checkedStandmans)
  },

  methods: {
    countShardProcent (currensShardsCount) {
      if (this.countStandmansSurveyAndShard.shards === 0) {
        return 0
      }

      return ((currensShardsCount / this.countStandmansSurveyAndShard.shards) * 100)
    },

    countSurveysProcent (currensSurveyssCount) {
      if (this.countStandmansSurveyAndShard.surveys === 0) {
        return 0
      }

      return ((currensSurveyssCount / this.countStandmansSurveyAndShard.surveys) * 100)
    },

    checkAll () {
      this.checkedStandmans = this.standmans.map((elem) => elem._id)
    },

    onCheckAll () {
      if (this.checkedAll) {
        this.checkedStandmans = []
      } else {
        this.checkAll()
      }

      this.$emit('onChange', this.checkedStandmans)
      this.checkedAll = !this.checkedAll
    },

    onChange (e) {
      this.$emit('onChange', e)

      if (this.checkedStandmans.length === 0) {
        this.checkedAll = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-table {
  width: 100%;
  font-size: 14px;
}

.data-table td {
  padding: 0 20px;
}

.data-table .data-table__body tr:last-child {
  font-weight: bold;
  color: #fff;

  background-color: #9a99a2;
  border: none;
}

.data-table tr {
  height: 64px;
  border-bottom: 1px solid rgba(230, 228, 234, 0.64);

  &:last-child td {
    &:first-child {
      border-radius: 0 0 0 10px;
    }

    &:last-child {
      border-radius: 0 0 10px 0;
    }
  }
}

.data-table th {
  background-color:var(--v-v_sub_bg-base)!important;
  padding: 0 20px;

  &:first-child {
    padding-right: 0;
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 0 10px 0 0;
  }
}

.data-table__body {
  background: #f3f2f7;
}
.standman-color {
  height: 15px;
  width: 15px;
  border-radius: 50%;
}
.first-column {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
